<div class="dashboard-page">
  @if (analyticsData(); as data) {
    <!-- Карточки с типами мяса -->
    <app-quota-animals-grid
      [cards]="allCards()"
      [active]="selectedCard()"
      (selectCard)="onCardSelected($event)">
    </app-quota-animals-grid>

    <!-- Графики в зависимости от выбранной карточки -->
    @if (selectedCard(); as selected) {
      <div class="charts-grid">
        <!-- 1. Топ исторических поставщиков -->
        <app-top-suppliers-donut
          [title]="'dashboard.topHistoricalSuppliers' | translate"
          [suppliers]="selected.topHistoricalSuppliers">
        </app-top-suppliers-donut>

        <!-- 2. Топ новых поставщиков -->
        <app-top-suppliers-donut
          [title]="'dashboard.topNewSuppliers' | translate"
          [suppliers]="selected.topNewSuppliers">
        </app-top-suppliers-donut>

        <!-- 3. Распределённые квоты -->
        <app-allocated-quotas-donut
          [title]="'dashboard.allocatedQuotas' | translate"
          [totalVolume]="selected.totalVolume"
          [totalAllocated]="selected.totalAllocated"
          [remainingVolume]="selected.remainingVolume">
        </app-allocated-quotas-donut>

        <!-- 4. Топ-5 исторических поставщиков с низким использованием квоты -->
        <app-top-suppliers-donut
          [title]="'dashboard.topHistoricalLowUsage' | translate"
          [suppliers]="selected.antiTopHistoricalSuppliers">
        </app-top-suppliers-donut>

        <!-- 5. Топ-5 новых поставщиков с низким использованием квоты -->
        <app-top-suppliers-donut
          [title]="'dashboard.topNewLowUsage' | translate"
          [suppliers]="selected.antiTopNewSuppliers">
        </app-top-suppliers-donut>

        <!-- 6. Процент использования (импорта) квот -->
        <app-usage-percentage-donut
          [title]="'dashboard.usagePercentage' | translate"
          [totalAllocated]="selected.totalAllocated"
          [usagePercentage]="selected.usagePercentage">
        </app-usage-percentage-donut>
      </div>

      <!-- Блок с двумя графиками в ряд -->
      <div class="two-column-grid">
        <!-- Сравнение типов поставщиков -->
        <app-supplier-type-limits-compare
          [quotaHistoricalSupplierTypeLimit]="selected.quotaHistoricalSupplierTypeLimit"
          [quotaNewSupplierTypeLimit]="selected.quotaNewSupplierTypeLimit">
        </app-supplier-type-limits-compare>

        <!-- Дедлайны квот -->
        <app-quota-deadlines-bars
          [title]="'dashboard.distributionDeadline' | translate"
          [quotaDeadlines]="selected.quotaDeadlines">
        </app-quota-deadlines-bars>
      </div>

      <!-- Последние заявки -->
      <div class="full-width-section">
        <app-latest-applications
          [title]="'dashboard.latestApplications' | translate"
          [newApplications]="selected.newApplications">
        </app-latest-applications>
      </div>
    }
  }
</div>
